import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { TagType } from 'types/tag'
import { fetchTagsAction } from 'reducks/tag/actions'

const fetchTags = (isPublished?: string) => {
  return async (dispatch: Dispatch<Action>) => {
    let query = db.collection('tags').where('is_deleted', '==', false)

    if (typeof isPublished !== 'undefined' && isPublished == 'published') {
      query = query.where('is_published', '==', true)
    } else if (typeof isPublished !== 'undefined' && isPublished == 'unpublished') {
      query = query.where('is_published', '==', false)
    }

    const tags = await query
      .orderBy('created_at', 'asc')
      .get()
      .then((snapshots) => {
        const _tags: TagType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as TagType
          _tags.push(data)
        })
        return _tags
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchTagsAction(tags))
  }
}

export default fetchTags
